import { supabase } from '../supabaseClient';

const VAPID_PUBLIC_KEY =
  'BK-OutGtQzhqWj061XANsJpuhaezFL7BbCTWQMxbpRj39uQQuXXrz-0qEib01CNayij67nL1dfAvHXTMgClOf9o';
const NATIVE_PUSH_WORKER_PATH = '/native-push-worker.js';

const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
};

const waitForActiveServiceWorker = async (registration) => {
  if (registration.active) {
    return registration;
  }

  const worker = registration.installing || registration.waiting;

  if (worker) {
    await new Promise((resolve, reject) => {
      const timeoutId = setTimeout(() => {
        reject(new Error('SERVICE_WORKER_ACTIVATION_TIMEOUT'));
      }, 15000);

      worker.addEventListener('statechange', () => {
        if (worker.state === 'activated') {
          clearTimeout(timeoutId);
          resolve();
        }
      });
    });
  }

  if (!registration.active) {
    await navigator.serviceWorker.ready;
  }

  if (!registration.active) {
    throw new Error('SERVICE_WORKER_NOT_ACTIVE');
  }

  return registration;
};

export const getNativePushRegistration = async () => {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return null;
  }

  const registration = await navigator.serviceWorker.register(NATIVE_PUSH_WORKER_PATH, {
    scope: '/',
    updateViaCache: 'none',
  });

  await registration.update().catch(() => {});

  return waitForActiveServiceWorker(registration);
};

export const getNativePushSubscription = async () => {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return null;
  }

  const registrations = await navigator.serviceWorker.getRegistrations();
  const registration = registrations.find((item) =>
    item.active?.scriptURL?.endsWith(NATIVE_PUSH_WORKER_PATH)
  );

  return registration?.pushManager?.getSubscription() ?? null;
};

export const hasNativePushSubscription = async () => {
  const subscription = await getNativePushSubscription();
  return Boolean(subscription?.endpoint);
};

export const syncNativePushSubscription = async () => {
  const subscription = await getNativePushSubscription();

  if (!subscription?.endpoint) {
    return false;
  }

  await saveNativePushSubscription(subscription);
  return true;
};

export const subscribeNativePush = async () => {
  const registration = await getNativePushRegistration();
  if (!registration?.pushManager) {
    throw new Error('Tu navegador no permite registrar notificaciones push nativas.');
  }

  let subscription = await registration.pushManager.getSubscription();

  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });
  }

  return subscription;
};

export const saveNativePushSubscription = async (subscription) => {
  if (!subscription?.endpoint) {
    throw new Error('Suscripción push nativa inválida.');
  }

  const { data, error } = await supabase.rpc('upsert_push_subscription', {
    p_subscription: subscription.toJSON(),
    p_user_agent: navigator.userAgent,
  });

  if (error) {
    throw error;
  }

  return data;
};
